import axios from "axios";

async function postActionLog(quoteKey, type, description = "", documentId = null) {
    try {
        await axios.post(`/quote/${quoteKey}/logs`, {
            type,
            description,
            ...(documentId != null ? { document_id: documentId } : {}),
        });
        return true;
    } catch (error) {
        console.warn("Failed to log action", error);
        return false;
    }
}

export async function logQuoteDocumentOpen(quoteKey, name, documentId = null) {
    return await postActionLog(quoteKey, "quote_document_open", name, documentId);
}

export async function logQuoteOptionExtraDocumentOpen(quoteKey, name) {
    return await postActionLog(quoteKey, "quote_option_extra_document_open", name);
}

export async function logQuoteSignatureViewOpen(quoteKey) {
    await postActionLog(quoteKey, "quote_signature_view_open");
}

export async function logQuoteDocumentSignatureViewOpen(quoteKey) {
    await postActionLog(quoteKey, "quote_document_signature_view_open");
}

export async function logReadMoreOpen(quoteKey, title) {
    await postActionLog(quoteKey, "read_more_open", title);
}

export async function logQuoteButtonClick(quoteKey, name) {
    await postActionLog(quoteKey, "button_click", name);
}

export async function logAISRequested(quoteKey, description) {
    await postActionLog(quoteKey, "ais_requested", description);
}

export async function logAISModuleRendered(quoteKey) {
    await postActionLog(quoteKey, "ais_module_rendered");
}

export async function logAISAuthenticationCompleted(quoteKey) {
    await postActionLog(quoteKey, "ais_authentication_completed");
}

export async function logAISAccountsRetrieved(quoteKey, description) {
    await postActionLog(quoteKey, "ais_accounts_retrieved", description);
}

// The brite_ais_* vocabulary is Brite's alone. Billecta keeps emitting the
// ais_* keys above, and historical rows of both keep rendering.
export async function logBriteAISModuleRendered(quoteKey) {
    await postActionLog(quoteKey, "brite_ais_module_rendered");
}

export async function logBriteAISAccountsRetrieved(quoteKey, description) {
    await postActionLog(quoteKey, "brite_ais_accounts_retrieved", description);
}
